import { transformCoordinates, transformLength, ZodOutputFor } from "@opstel/query/zod-utils";
import { z } from "zod/v3";
import { Length } from "@shared/common/utils/length";
import { Track, trackSchema } from "./track";
import { DirectionalList } from "./types/directionalList";
import { Point } from "@opstel/geo/Point";
import { pointSchema } from "./point";

export interface TrackGroup {
  type: "TrackGroup";
  code: string;
  name: string;
  length: Length;
  tracks: Track[];
}

export interface TrackGroupWithGeometry extends TrackGroup {
  coordinates: DirectionalList<Point>;
}

export interface TrackGroup {
  type: "TrackGroup";
  code: string;
  name: string;
  length: Length;
  tracks: Track[];
}

export const trackGroupSchema = z
  .object({
    code: z.string().min(1, "TrackGroup code should not be empty"),
    name: z.string().min(1, "TrackGroup name should not be empty"),
    lengthInMm: z.number(),
    tracks: z.array(trackSchema).min(2, "TrackGroup should have at least 2 tracks"),
  })
  .transform(transformLength)
  .transform((trackGroup) => ({
    ...trackGroup,
    type: "TrackGroup",
  })) satisfies ZodOutputFor<TrackGroup>;

export const trackGroupWithGeometrySchema = z
  .object({
    code: z.string().min(1, "TrackGroup code should not be empty"),
    name: z.string().min(1, "TrackGroup name should not be empty"),
    lengthInMm: z.number(),
    tracks: z.array(trackSchema).min(2, "TrackGroup should have at least 2 tracks"),
    coordinatesFromSourceToTarget: z
      .array(pointSchema)
      .min(2, "TrackGroup should have coordinates"),
  })
  .transform(transformLength)
  .transform(transformCoordinates)
  .transform((trackGroup) => ({
    ...trackGroup,
    type: "TrackGroup",
  })) satisfies ZodOutputFor<TrackGroupWithGeometry>;
